import { useMemo } from 'react';
import { useUnit } from 'effector-react';
import { $banksMap } from '../../model';

export const useBankCodeOptions = () => {
    const banksMap = useUnit($banksMap);

    return useMemo(
        () =>
            [...banksMap.values()].map((bank) => ({
                value: bank.code,
                label: bank.name_ru,
            })),
        [banksMap],
    );
};
